import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../axiosInstances";
import {
  RealOrganizerEvent,
  GetManualViewsHistoryParams,
  QueryArgs,
  PaginatedResponse,
  ManualViewsHistoryItem,
  Paginated,
  GetRealOrganizerEventsParams,
} from "@ac-expo/api-types";
import { acExpoQueryKeys } from "../query-keys/ac-expo.query-keys";

const getRealOrganizerEvents = async (
  params?: GetRealOrganizerEventsParams
) => {
  const searchParams = new URLSearchParams();

  if (params?.search) {
    searchParams.append("search", params.search);
  }

  const response = await privateAxios.get<RealOrganizerEvent[]>(
    `/ac-expo/real-organizer-events?${searchParams}`
  );
  return response.data;
};

export const useGetRealOrganizerEvents = (
  params?: GetRealOrganizerEventsParams
) => {
  return useQuery({
    queryKey: acExpoQueryKeys.realOrganizerEvents(params),
    queryFn: () => getRealOrganizerEvents(params),
  });
};

const getManualViewsHistory = async (
  params?: Paginated<GetManualViewsHistoryParams>
) => {
  const { pagination, ...rest } = params || {};

  const response = await privateAxios.get<
    PaginatedResponse<ManualViewsHistoryItem>
  >(`/ac-expo/manual-views-history`, {
    params: {
      ...rest,
      pagination,
    },
  });

  return response.data;
};

export const useGetManualViewsHistory = (
  params?: Paginated<GetManualViewsHistoryParams> | undefined,
  options?: QueryArgs<PaginatedResponse<ManualViewsHistoryItem>>
) => {
  return useQuery({
    queryKey: acExpoQueryKeys.manualViewsHistory(params),
    queryFn: () => getManualViewsHistory(params),
    ...options,
  });
};
